import { useState, useCallback } from 'react';
import { pwh203Api } from '../../../services/pwh203Api';

export function usePWH203Navigation(loadRecord: (id: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  const loadList = useCallback(async () => {
    try {
      const res = await pwh203Api.list(1, 100);
      const ids = res.data.map((r) => r.fh130_01);
      setAllIds(ids);
      if (ids.length > 0) {
        setCurrentIdx(0);
        await loadRecord(ids[0]);
      }
    } catch {
      // silently fail on initial load
    }
  }, [loadRecord]);

  const navTo = useCallback(
    async (idx: number) => {
      if (idx < 0 || idx >= allIds.length) return;
      setCurrentIdx(idx);
      await loadRecord(allIds[idx]);
    },
    [allIds, loadRecord]
  );

  return { allIds, currentIdx, loadList, navTo };
}
